import { Button, Form } from 'antd';
import React, { useMemo } from 'react';

import FilterActions from '../../../../../../../RoomsAcceptance/shared/ui/FilterActions';
import FilterContainer from '../../../../../../../RoomsAcceptance/shared/ui/FilterContainer';
import StyledSelect from '../StyledSelect';
import {
  serviceSetFilterFieldNames,
  serviceSetFilterSelectionValues,
} from '../../CreateNewWorkScheduleByPeriod.constants';
import styles from './ServiceSetsSection.module.scss';
import {
  createOptionSearch,
  getArrayValue,
  getSelectedFirstOptions,
} from './utils';

export const ServiceSetsFilter = ({
  form,
  isEditable,
  serviceOptions,
  servicesLoading,
  onClose,
}) => {
  const { getFieldValue, setFieldsValue } = form;
  const serviceValue = getArrayValue(
    getFieldValue(serviceSetFilterFieldNames.service)
  );
  const immediateValue = Boolean(
    getFieldValue(serviceSetFilterFieldNames.immediate)
  );
  const selectionValue = getFieldValue(serviceSetFilterFieldNames.selection);
  const sortedServiceOptions = useMemo(
    () => getSelectedFirstOptions(serviceOptions, serviceValue),
    [serviceOptions, serviceValue]
  );
  const hasActiveFilters = Boolean(
    serviceValue.length || immediateValue || selectionValue
  );

  const handleReset = () => {
    setFieldsValue({
      [serviceSetFilterFieldNames.immediate]: false,
      [serviceSetFilterFieldNames.service]: [],
      [serviceSetFilterFieldNames.selection]: '',
    });
    onClose();
  };

  const handleChange = (value) => {
    setFieldsValue({
      [serviceSetFilterFieldNames.service]: getArrayValue(value),
    });
  };

  const handleImmediateToggle = () => {
    setFieldsValue({
      [serviceSetFilterFieldNames.immediate]: !immediateValue,
    });
  };

  const handleSelectionToggle = (value) => {
    setFieldsValue({
      [serviceSetFilterFieldNames.selection]:
        selectionValue === value ? '' : value,
    });
  };

  return (
    <FilterContainer>
      <div className={styles.serviceSetSelectionFilters}>
        <Button
          className={styles.serviceSetSelectionFilters_btn}
          type={immediateValue ? 'primary' : 'default'}
          onClick={handleImmediateToggle}
        >
          Аварийные
        </Button>
        <Button
          className={styles.serviceSetSelectionFilters_btn}
          type={
            selectionValue === serviceSetFilterSelectionValues.selected
              ? 'primary'
              : 'default'
          }
          onClick={() =>
            handleSelectionToggle(serviceSetFilterSelectionValues.selected)
          }
        >
          Показать выбранные
        </Button>
        <Button
          className={styles.serviceSetSelectionFilters_btn}
          type={
            selectionValue === serviceSetFilterSelectionValues.unselected
              ? 'primary'
              : 'default'
          }
          onClick={() =>
            handleSelectionToggle(serviceSetFilterSelectionValues.unselected)
          }
        >
          Показать не выбранные
        </Button>
      </div>
      <Form.Item label="Услуга" className={styles.formItem}>
        <StyledSelect
          createSearch={createOptionSearch}
          disabled={!isEditable || servicesLoading}
          id="serviceSetFilterService"
          loading={servicesLoading}
          multiple
          name={serviceSetFilterFieldNames.service}
          options={sortedServiceOptions}
          placeholder="Все услуги"
          showSelectionActions
          value={serviceValue}
          onChange={handleChange}
        />
      </Form.Item>
      <FilterActions
        resetDisabled={!hasActiveFilters}
        applyDisabled={!hasActiveFilters}
        onReset={handleReset}
        onApply={onClose}
      />
    </FilterContainer>
  );
};

export const ServiceSetSelectFilter = ({
  form,
  isEditable,
  serviceOptions,
  onClose,
}) => {
  const { getFieldValue, setFieldsValue } = form;
  const serviceValue = getArrayValue(
    getFieldValue(serviceSetFilterFieldNames.service)
  );
  const selectionValue = getFieldValue(serviceSetFilterFieldNames.selection);
  const sortedServiceOptions = useMemo(
    () => getSelectedFirstOptions(serviceOptions, serviceValue),
    [serviceOptions, serviceValue]
  );
  const hasActiveFilters = Boolean(serviceValue.length || selectionValue);

  const handleReset = () => {
    setFieldsValue({
      [serviceSetFilterFieldNames.service]: [],
      [serviceSetFilterFieldNames.selection]: '',
    });
    onClose();
  };

  const handleChange = (value) => {
    setFieldsValue({
      [serviceSetFilterFieldNames.service]: getArrayValue(value),
    });
  };

  const handleSelectionToggle = (value) => {
    setFieldsValue({
      [serviceSetFilterFieldNames.selection]:
        selectionValue === value ? '' : value,
    });
  };

  return (
    <FilterContainer>
      <div className={styles.serviceSetSelectionFilters}>
        <Button
          className={styles.serviceSetSelectionFilters_btn}
          type={
            selectionValue === serviceSetFilterSelectionValues.immediate
              ? 'primary'
              : 'default'
          }
          onClick={() =>
            handleSelectionToggle(serviceSetFilterSelectionValues.immediate)
          }
        >
          Аварийные
        </Button>
      </div>
      <Form.Item label="Услуга" className={styles.formItem}>
        <StyledSelect
          createSearch={createOptionSearch}
          disabled={!isEditable}
          id="serviceSetSelectFilterService"
          multiple
          name={serviceSetFilterFieldNames.service}
          options={sortedServiceOptions}
          placeholder="Все услуги"
          showSelectionActions
          value={serviceValue}
          onChange={handleChange}
        />
      </Form.Item>
      <FilterActions
        resetDisabled={!hasActiveFilters}
        applyDisabled={!hasActiveFilters}
        onReset={handleReset}
        onApply={onClose}
      />
    </FilterContainer>
  );
};
